"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entry = Entry;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var content_1 = require("./components/dialogs/content");
var message_1 = require("./components/dialogs/message");
var auth_1 = require("./features/slices/auth");
var dashboard_1 = require("./pages/dashboard");
var account_settings_1 = require("./pages/dashboard/account/account-settings");
var alterations_1 = require("./pages/dashboard/alterations/alterations");
var analysis_1 = require("./pages/dashboard/analysis/analysis");
var asset_edit_1 = require("./pages/dashboard/assets/asset-edit");
var assets_1 = require("./pages/dashboard/assets/assets");
var area_management_page_1 = require("./pages/dashboard/building-areas/area-management-page");
var building_areas_1 = require("./pages/dashboard/building-areas/building-areas");
var home_1 = require("./pages/dashboard/home");
var integrations_1 = require("./pages/dashboard/integrations/integrations");
// import { LeaseEditPage } from "./pages/dashboard/leases/lease-edit";
// import { LeasesPage } from "./pages/dashboard/leases/leases";
var meter_readings_1 = require("./pages/dashboard/meter-readings/meter-readings");
var reading_edit_1 = require("./pages/dashboard/meter-readings/reading-edit");
var meter_edit_1 = require("./pages/dashboard/meters/meter-edit");
var meters_1 = require("./pages/dashboard/meters/meters");
var rate_periods_1 = require("./pages/dashboard/rate-periods/rate-periods");
var removal_requests_1 = require("./pages/dashboard/removal-requests/removal-requests");
var service_edit_1 = require("./pages/dashboard/services/service-edit");
var services_1 = require("./pages/dashboard/services/services");
var tenant_management_page_1 = require("./pages/dashboard/tenants/tenant-management-page");
var tenants_1 = require("./pages/dashboard/tenants/tenants");
var usage_1 = require("./pages/dashboard/usage/usage");
var user_edit_1 = require("./pages/dashboard/users/user-edit");
var users_1 = require("./pages/dashboard/users/users");
var forgot_password_1 = require("./pages/forgot-password");
var login_1 = require("./pages/login");
var not_found_1 = require("./pages/not-found");
var reset_password_1 = require("./pages/reset-password");
var sign_up_1 = require("./pages/sign-up");
var hooks_1 = require("./store/hooks");
var auth_storage_1 = require("./utils/auth-storage");
function Entry() {
    var dispatch = (0, hooks_1.useAppDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var routes = (0, react_router_dom_1.useRoutes)([
        {
            path: "/",
            index: true,
            element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "login", replace: true }),
        },
        {
            path: "login",
            element: (0, jsx_runtime_1.jsx)(login_1.LoginPage, {}),
        },
        {
            path: "forgot-password",
            element: (0, jsx_runtime_1.jsx)(forgot_password_1.ForgotPasswordPage, {}),
        },
        {
            path: "reset-password",
            element: (0, jsx_runtime_1.jsx)(reset_password_1.ResetPasswordPage, {}),
        },
        {
            path: "sign-up",
            element: (0, jsx_runtime_1.jsx)(sign_up_1.SignUpPage, {}),
        },
        {
            path: "dashboard/",
            element: (0, jsx_runtime_1.jsx)(dashboard_1.DashboardIndex, {}),
            children: [
                { path: "home", element: (0, jsx_runtime_1.jsx)(home_1.HomePage, {}) },
                { path: "tenants", element: (0, jsx_runtime_1.jsx)(tenants_1.TenantsPage, {}) },
                { path: "tenants/new", element: (0, jsx_runtime_1.jsx)(tenant_management_page_1.TenantManagementPage, {}) },
                { path: "tenants/:tenantId", element: (0, jsx_runtime_1.jsx)(tenant_management_page_1.TenantManagementPage, {}) },
                { path: "assets", element: (0, jsx_runtime_1.jsx)(assets_1.AssetsPage, {}) },
                { path: "assets/:assetId", element: (0, jsx_runtime_1.jsx)(asset_edit_1.AssetEditPage, {}) },
                { path: "meters", element: (0, jsx_runtime_1.jsx)(meters_1.MetersPage, {}) },
                { path: "meters/:meterId", element: (0, jsx_runtime_1.jsx)(meter_edit_1.MeterEditPage, {}) },
                { path: "areas", element: (0, jsx_runtime_1.jsx)(building_areas_1.BuildingAreasPage, {}) },
                { path: "areas/new", element: (0, jsx_runtime_1.jsx)(area_management_page_1.AreaManagementPage, {}) },
                { path: "areas/:areaId", element: (0, jsx_runtime_1.jsx)(area_management_page_1.AreaManagementPage, {}) },
                // { path: "leases", element: <LeasesPage /> },
                // { path: "leases/:leaseId", element: <LeaseEditPage /> },
                { path: "services", element: (0, jsx_runtime_1.jsx)(services_1.ServicesPage, {}) },
                { path: "services/:serviceId", element: (0, jsx_runtime_1.jsx)(service_edit_1.ServiceEditPage, {}) },
                { path: "meter-readings", element: (0, jsx_runtime_1.jsx)(meter_readings_1.MeterReadingsPage, {}) },
                { path: "meter-readings/:readingId", element: (0, jsx_runtime_1.jsx)(reading_edit_1.ReadingEditPage, {}) },
                { path: "usage", element: (0, jsx_runtime_1.jsx)(usage_1.UsagePage, {}) },
                { path: "analysis", element: (0, jsx_runtime_1.jsx)(analysis_1.AnalysisPage, {}) },
                { path: "alterations", element: (0, jsx_runtime_1.jsx)(alterations_1.AlterationsPage, {}) },
                { path: "rate-periods", element: (0, jsx_runtime_1.jsx)(rate_periods_1.RatePeriodsPage, {}) },
                { path: "integrations", element: (0, jsx_runtime_1.jsx)(integrations_1.IntegrationsPage, {}) },
                { path: "users", element: (0, jsx_runtime_1.jsx)(users_1.UsersPage, {}) },
                { path: "users/:userId", element: (0, jsx_runtime_1.jsx)(user_edit_1.UserEditPage, {}) },
                { path: "removal-requests", element: (0, jsx_runtime_1.jsx)(removal_requests_1.RemovalRequestsPage, {}) },
                { path: "account/settings", element: (0, jsx_runtime_1.jsx)(account_settings_1.AccountSettingsPage, {}) },
            ],
        },
        //
        // KEEP THE "NOT FOUND" ROUTE BELOW ALL OTHER ROUTES!
        //
        {
            path: "/*",
            element: (0, jsx_runtime_1.jsx)(not_found_1.NotFoundPage, {}),
        },
    ]);
    (0, react_1.useEffect)(function () {
        var userData = (0, auth_storage_1.loadAuth)();
        if (userData) {
            dispatch((0, auth_1.setCredentials)(userData));
        }
        else {
            navigate("/login");
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "h-screen w-full", children: [routes, (0, jsx_runtime_1.jsx)(content_1.ContentDialog, {}), (0, jsx_runtime_1.jsx)(message_1.MessageDialog, {})] }));
}
